// Responsive breakpoints (canonical source of truth)
export const BREAKPOINTS = {
  desktop: 768,
  largeDesktop: 1024,
  wideDesktop: 1280,
  ultraWide: 1440,
  smallMobile: 480,
  narrow: 280, // Very narrow screens only - ensures 2 columns on all phones
} as const;
